import prod from './prod.env';
import dev from './dev.env';

const NODE_ENV = process.env.NODE_ENV;
const ENV = (NODE_ENV === 'production') ? prod : dev;

export default ENV;
